import React from "react";

import styles from "./HeaderTop.module.scss";
import { Link } from "react-router";

const HeaderTop: React.FC = () => {
  return (
    <div className={styles.top}>
      <nav className={styles.navigation}>
        <ul className={styles.list}>
          <li className={`${styles.item} animated-underline`}>
            <Link to="/gifts">Подарочные сертификаты</Link>
          </li>
          <li className={`${styles.item} animated-underline`}>
            <Link to="/sales-and-news">Акции</Link>
          </li>
          <li className={`${styles.item} animated-underline`}>
            <Link to="/schemas">Схемы и выкройки</Link>
          </li>
          <li className={styles.item} style={{ paddingBottom: 12, marginTop: 5 }}>
            Анкеты
            <ul className={styles.links}>
              <li className="animated-underline">
                <Link to="/young-designers">Анкета для молодых дизайнеров</Link>
              </li>
              <li className="animated-underline">
                <Link to="/sample-questionnare">Анкета для предоставления образцов</Link>
              </li>
            </ul>
          </li>
          <li className={styles.item} style={{ paddingBottom: 12, marginTop: 5 }}>
            Условия
            <ul className={styles.links}>
              <li className="animated-underline">
                <Link to="/how-to-pay">Как сделать заказ</Link>
              </li>
              <li className="animated-underline">
                <Link to="/delivery-and-payment">Доставка и оплата</Link>
              </li>
              <li className="animated-underline">
                <Link to="/goods-return">Условия возврата</Link>
              </li>
            </ul>
          </li>
          <li className={styles.item} style={{ paddingBottom: 12, marginTop: 5 }}>
            О нас
            <ul className={styles.links}>
              <li className="animated-underline">
                <Link to="/about-us">О компании</Link>
              </li>
              <li className="animated-underline">
                <Link to="/contacts">Контакты</Link>
              </li>
              <li className="animated-underline">
                <Link to="/vacancies">Вакансии</Link>
              </li>
              <li className="animated-underline">
                <Link to="/write-to-us">Написать нам</Link>
              </li>
              <li className="animated-underline">
                <Link to="/write-to-manager">Написать руководителю</Link>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
      <div className={styles.phone}></div>
    </div>
  );
};

export default HeaderTop;
